import { motion } from "framer-motion";

const galleryImages = [
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_pixora-moments/artifacts/g4m22ysq_ChatGPT%20Image%2024%20sept.%202026%2C%2011_08_13.png",
    alt: "Photobooth Pixora installé en extérieur avec parapluie flash",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_pixora-moments/artifacts/ja3oahjr_IMG20260919135240.webp",
    alt: "Table props photobooth mariage — accessoires, chapeaux, lunettes colorées",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_pixora-moments/artifacts/ouwfrswm_IMG20260919135303.webp",
    alt: "Livre d'or personnalisé Caroline & Alexandre",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_pixora-moments/artifacts/8dz7az8x_IMG20260919135535.webp",
    alt: "Panneaux photo « Je t'aime » et « Je suis ici pour l'apéro »",
  },
];

// Duplicate images so the marquee loops seamlessly
const marqueeImages = [...galleryImages, ...galleryImages];

export default function GallerySection() {
  return (
    <section className="py-16 md:py-20 bokeh-strong overflow-hidden" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 mb-10 md:mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-xs tracking-[0.3em] text-[#C9A962] mb-3">EN CONDITIONS RÉELLES</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white">
            Nos <span className="gradient-text">réalisations</span>
          </h2>
          <p className="text-[#B8A88A] mt-3 max-w-xl mx-auto text-sm md:text-base">
            Un aperçu de nos installations et de nos accessoires premium.
          </p>
        </motion.div>
      </div>

      {/* Marquee */}
      <div
        className="group relative"
        style={{
          maskImage:
            "linear-gradient(to right, transparent 0, black 6%, black 94%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0, black 6%, black 94%, transparent 100%)",
        }}
      >
        <div className="flex gap-5 md:gap-8 animate-marquee-x will-change-transform group-hover:[animation-play-state:paused]">
          {marqueeImages.map((img, i) => (
            <a
              key={`${img.src}-${i}`}
              href={img.src}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={img.alt}
              className="relative shrink-0 w-[240px] sm:w-[300px] md:w-[360px] aspect-[3/4] rounded-2xl overflow-hidden ring-1 ring-[#C9A962]/25 hover:ring-[#C9A962]/70 transition-all shadow-[0_10px_30px_rgba(0,0,0,0.5)]"
              data-testid={`gallery-image-${i % galleryImages.length}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
